import React from "react";

function Toast({ theme, message }) {
    return (
        <div className={`btoast ${theme || ''}`}>
            <p style={{ marginBottom: "0", textAlign: "center" }}>{message}</p>
        </div>
    );
}

export default Toast;
